module.exports = (opts) => {
  return opts
}



// WEBPACK FOOTER //
// ./src/private/scanners/date.js